import { Command } from './Command';
import { ChartEngine, NextBtnBox } from '../core/ChartEngine';

/**
 * 가이드 박스(HTML NextBtnBox)를 레이어에 추가하는 커맨드
 */
export class AddNextBtnBoxCommand implements Command {
  constructor(
    private regionId: string, 
    private layerId: string, 
    private box: NextBtnBox
  ) {}

  execute(engine: ChartEngine) { 
    engine.addNextBtnBoxToLayer(this.regionId, this.layerId, this.box); 
  }

  undo(engine: ChartEngine) { 
    engine.removeNextBtnBoxFromLayer(this.regionId, this.layerId, this.box.id); 
  }
}

/**
 * 가이드 박스(HTML NextBtnBox)를 레이어에서 제거하는 커맨드 (Undo 시 복구 지원)
 */
export class RemoveNextBtnBoxCommand implements Command {
  private savedBox: NextBtnBox | null = null;

  constructor(
    private regionId: string, 
    private layerId: string, 
    private boxId: string
  ) {}

  execute(engine: ChartEngine) {
    // 삭제 전 현재 상태를 스냅샷으로 찍어 저장 (Undo를 위함)
    const region = engine.getSnapshot().find(r => r.id === this.regionId);
    const layer = region?.layers.find(l => l.id === this.layerId);
    
    // 엔진의 htmlBoxes 배열에서 해당 ID를 찾아 저장
    this.savedBox = layer?.htmlBoxes?.find(b => b.id === this.boxId) || null;
    
    engine.removeNextBtnBoxFromLayer(this.regionId, this.layerId, this.boxId);
  }

  undo(engine: ChartEngine) {
    if (this.savedBox) {
      engine.addNextBtnBoxToLayer(this.regionId, this.layerId, this.savedBox);
    }
  }
}